export default __webpack_public_path__ + "static/media/car-fill.31a19503.svg";